<template>
  <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect x="5" y="12" width="22" height="2" fill="#3C3838"/>
    <rect x="9" y="18" width="4" height="2" rx="1" fill="#005AAA"/>
    <rect x="14" y="18" width="6" height="2" rx="1" fill="#ED1C24"/>
    <rect x="5.75" y="8.75" width="20.5" height="14.5" rx="2.25" stroke="#3C3838" stroke-width="1.5"/>
  </svg>

</template>
<script>
  export default {
    name: 'VnPayWallet'
  }
</script>



// WEBPACK FOOTER //
// src/components/icons/VnPayATM.vue